<template>
    <b-container fluid class="w-100 h-100 m-0 p-0 d-flex flex-column" :style="generateVariantStyle(Variant)">
        <b-row class="w-100 h-100 m-0 overflow-auto">
            <b-col class="m-0 p-1">
                <b-card class="bg-transparent border border-transparent h-100" :class="'border-' + Variant"
                        :id="$id('ExportDJUCard')" header-tag="header" no-body>
                    <template #header>
                        <b-row>
                            <b-col><h5 class="mb-0">{{ $t('ExportDJU') }}</h5></b-col>
                        </b-row>
                    </template>
                    <b-card-body class="d-flex flex-column">
                        <!-- Station Météo -->
                        <b-card :id="$id('StationCard')" class="border border-transparent m-0 mb-2 p-0"
                                :class="'outline-' + Variant" no-body>
                            <b-card-header header-tag="header" class="p-1" role="tab"
                                           :header-bg-variant="'outline-' + Variant">
                                <b-row>
                                    <b-col class="text-left" cols="11">
                                        <h6 class="m-0 p-1">
                                            {{ $t("MeteoStation") }} :
                                            {{ source > 0 ? sourceList.find(a => a.Id == source)?.Label : '' }}
                                            <template v-if="station > 0"> |
                                                {{ station > 0 ? stationList.find(a => a.Id == station)?.Label : '' }}
                                                |
                                                {{
                                                    type == "Climate" ? $t('MeteoTypeClimate') :
                                                        type == "DJU" ? $t('MeteoTypeDJU') :
                                                            type == "DJUReference" ? $t('MeteoTypeDJUReference') : ''
                                                }}
                                                <template v-if="type != 'Climate'">
                                                    |
                                                    {{
                                                        usage == 1 ? $t('MeteoHeating') :
                                                            usage == 7 ? $t('MeteoCooling') : ''
                                                    }}
                                                    | Seuil
                                                    {{ base + '°C' }}
                                                    |
                                                    {{ method > 0 ? methodList.find(a => a.Id == method)?.Label : '' }}
                                                </template>
                                            </template>
                                        </h6>
                                    </b-col>
                                    <b-col class="d-flex justify-content-end">
                                        <b-button v-if="collapsedStation" size="sm"
                                                  class="bg-transparent border-0 text-black"
                                                  @click.stop="collapsedStation = !collapsedStation">
                                            <!-- Close -> "Fermer" -->
                                            <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                    role="button"/>
                                        </b-button>

                                        <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                                  @click.stop="collapsedStation = !collapsedStation">
                                            <!-- Open -> "Ouvrir" -->
                                            <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down"
                                                    scale="1.5" role="button"/>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-card-header>
                            <b-card-body class="p-2 m-0" v-if="collapsedStation">
                                <b-row class="pb-2 px-3">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Source')">{{ $t('MeteoSource') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-form-select :id="$id('Source')" :variant="Variant"
                                                       v-model="source" :options="sourceList"
                                                       value-field="Id" text-field="Label" plain
                                                       class="align-middle align-items-center"/>
                                    </b-col>
                                </b-row>
                                <b-row class="pb-2 px-3" v-if="source != 0">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Station')">{{ $t('MeteoStationName') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-form-select :id="$id('Station')" :variant="Variant"
                                                       v-model="station" :options="stationList"
                                                       value-field="Id" text-field="Label" plain
                                                       class="align-middle align-items-center"/>
                                    </b-col>
                                </b-row>
                                <b-row class="pb-2 px-3" v-if="station != 0">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('TypeDatas')">{{ $t('MeteoType') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-form-radio-group name="TypeDatas"
                                                            :id="$id('TypeDatas')" plain
                                                            v-model="type" :variant="Variant"
                                                            class="align-middle align-items-center">
                                            <b-form-radio
                                                :disabled="station > 0 && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                value="Climate">{{ $t('MeteoTypeClimate') }}
                                            </b-form-radio>
                                            <b-form-radio value="DJU">{{ $t('MeteoTypeDJU') }}</b-form-radio>
                                            <b-form-radio value="DJUReference">{{
                                                    $t('MeteoTypeDJUReference')
                                                }}
                                            </b-form-radio>
                                        </b-form-radio-group>
                                    </b-col>
                                </b-row>
                                <b-row class="pb-2 px-3" v-if="station != 0 && type != '' && type != 'Climate'">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Usage')">{{ $t('MeteoUsage') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-form-radio-group name="Usage"
                                                            :id="$id('Usage')" plain
                                                            v-model="usage" :variant="Variant"
                                                            class="align-middle align-items-center">
                                            <b-form-radio value="1"
                                                          :disabled="this.stationInfo?.Extras['MeteoCorrectors']
                                                          .findIndex(a => a.Usage == 1  /* Chauffage */) == -1">
                                                {{ $t('MeteoHeating') }}
                                            </b-form-radio>
                                            <b-form-radio value="7"
                                                          :disabled="this.stationInfo?.Extras['MeteoCorrectors']
                                                          .findIndex(a => a.Usage == 7  /* Climatisation */) == -1">
                                                {{ $t('MeteoCooling') }}
                                            </b-form-radio>
                                        </b-form-radio-group>
                                    </b-col>
                                </b-row>
                                <b-row class="pb-2 px-3" v-if="station != 0 && type != '' && type != 'Climate'">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Base')">{{ $t('MeteoBase') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-input-group append="°C" plain
                                                       class="align-middle align-items-center">
                                            <b-form-input :id="$id('Base')" :variant="Variant" type="number" min="0"
                                                          max="50"
                                                          v-if="stationInfo?.Extras['HasClimateDatas'] == yesNoEnum[1].id"
                                                          v-model="base" plain/>
                                            <b-form-select :id="$id('Base')" :variant="Variant" v-else
                                                           v-model="base" :options="baseList"
                                                           value-field="Value" text-field="Value" plain
                                                           class="align-middle align-items-center"/>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row class="pb-2 px-3" v-if="station != 0 && type != '' && type != 'Climate'">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Method')">{{ $t('MeteoMethod') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-form-radio-group :id="$id('Method')" :variant="Variant"
                                                            v-model="method" plain
                                                            class="align-middle align-items-center">
                                            <template v-for="method in methodList">
                                                <b-form-radio :value="method.Id"
                                                              :disabled="stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id &&
                                                                    stationInfo?.Extras['MeteoCorrectors']
                                                                            .findIndex(a => a.Method == method.Id) == -1">
                                                    {{ method.Label }}
                                                </b-form-radio>
                                            </template>
                                        </b-form-radio-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>

                        <!-- Période -->
                        <b-card :id="$id('IntervalCard')" class="border border-transparent m-0 mb-2 p-0"
                                :class="'outline-' + Variant"
                                no-body>
                            <b-card-header header-tag="header" class="p-1" role="tab"
                                           :header-bg-variant="'outline-' + Variant">
                                <b-row>
                                    <b-col class="text-left" cols="11">
                                        <h6 class="m-0 p-1">
                                            {{ $t(interval) }} :
                                            <template v-if="interval == 'Year'">
                                                {{ startYear + ' - ' + endYear }}
                                            </template>
                                            <template v-if="interval == 'Month'">
                                                {{ startMonth + '/' + startYear + ' - ' + endMonth + '/' + endYear }}
                                            </template>
                                            <template v-if="interval == 'Period'">
                                                {{
                                                    new Date(startDate).toLocaleDateString() + ' - ' + new Date(endDate).toLocaleDateString()
                                                }}
                                            </template>
                                        </h6>
                                    </b-col>
                                    <b-col class="d-flex justify-content-end">
                                        <b-button v-if="collapsedInterval" size="sm"
                                                  class="bg-transparent border-0 text-black"
                                                  @click.stop="collapsedInterval = !collapsedInterval">
                                            <!-- Close -> "Fermer" -->
                                            <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                    role="button"/>
                                        </b-button>

                                        <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                                  @click.stop="collapsedInterval = !collapsedInterval">
                                            <!-- Open -> "Ouvrir" -->
                                            <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down"
                                                    scale="1.5" role="button"/>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-card-header>
                            <b-card-body class="p-2 m-0" v-if="collapsedInterval">
                                <b-row class="pb-2 px-3">
                                    <b-col cols="2" align-v="center" class="p-0">
                                        <label :for="$id('Interval')">{{ $t('MeteoInterval') }}</label>
                                    </b-col>
                                    <b-col align-v="center">
                                        <b-button :pressed="interval == 'Year'" @click.stop="interval = 'Year'"
                                                  size="sm" class="mr-1 mb-1 flex-grow-1"
                                                  :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                  :variant="(interval == 'Year' ? '' : 'outline-') + Variant ">
                                            {{ $t('Year') }}
                                        </b-button>
                                        <b-button :pressed="interval == 'Month'" @click.stop="interval = 'Month'"
                                                  size="sm" class="mr-1 mb-1 flex-grow-1"
                                                  :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                  :variant="(interval == 'Month' ? '' : 'outline-') + Variant ">
                                            {{ $t('Month') }}
                                        </b-button>
                                        <b-button :pressed="interval == 'Period'" @click.stop="interval = 'Period'"
                                                  size="sm" class="mr-1 mb-1 flex-grow-1"
                                                  :variant="(interval == 'Period' ? '' : 'outline-') + Variant ">
                                            {{ $t('Period') }}
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <template v-if="interval == 'Period'">
                                    <b-row class="pb-2 px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('StartDate')">{{ $t('StartDate') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-input-group plain class="align-middle align-items-center">
                                                <b-form-input :id="$id('StartDate')" :variant="Variant"
                                                              type="date" min="0" max="50"
                                                              :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                              v-model="startDate" plain/>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('EndDate')">{{ $t('EndDate') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-input-group plain class="align-middle align-items-center">
                                                <b-form-input :id="$id('EndDate')" :variant="Variant"
                                                              type="date" min="0" max="50"
                                                              :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                              v-model="endDate" plain/>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template v-if="interval == 'Year'">
                                    <b-row class="pb-2 px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('start')">{{ $t('Start') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-form-select :id="$id('start')" :options="yearList"
                                                           value-field="Id" text-field="Label" :variant="Variant"
                                                           :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                           plain v-model="startYear" class="w-100"/>
                                        </b-col>
                                    </b-row>
                                    <b-row class="px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('end')">{{ $t('End') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-form-select :id="$id('end')" :options="yearList"
                                                           value-field="Id" text-field="Label" :variant="Variant"
                                                           :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                           plain v-model="endYear" class="w-100"/>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template v-if="interval == 'Month'">
                                    <b-row class="pb-2 px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('StartDate')">{{ $t('Start') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-row class="p-0 m-0">
                                                <b-col class="pr-1 p-0" cols="6">
                                                    <b-form-select :options="monthList" value-field="Id"
                                                                   text-field="Label" plain :variant="Variant"
                                                                   :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                                   v-model="startMonth" class="w-100"/>
                                                </b-col>
                                                <b-col class="pl-1 p-0" cols="6">
                                                    <b-form-select :options="yearList" value-field="Id"
                                                                   text-field="Label" :variant="Variant"
                                                                   :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                                   plain v-model="startYear" class="w-100"/>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row class="px-3">
                                        <b-col cols="2" align-v="center" class="p-0">
                                            <label :for="$id('EndDate')">{{ $t('End') }}</label>
                                        </b-col>
                                        <b-col align-v="center">
                                            <b-row class="p-0 m-0">
                                                <b-col class="pr-1 p-0" cols="6">
                                                    <b-form-select :options="monthList" value-field="Id"
                                                                   :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                                   text-field="Label" plain :variant="Variant"
                                                                   v-model="endMonth" class="w-100"/>
                                                </b-col>
                                                <b-col class="pl-1 p-0" cols="6">
                                                    <b-form-select :options="yearList" value-field="Id"
                                                                   :disabled="type == 'DJUReference' && stationInfo?.Extras['HasClimateDatas'] != yesNoEnum[1].id"
                                                                   text-field="Label" :variant="Variant"
                                                                   plain v-model="endYear" class="w-100"/>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-card-body>
                        </b-card>

                        <!-- Bouton de demande -->
                        <b-row class="pb-2 px-3">
                            <b-col align-v="center" class="h-100 text-center">
                                <b-button @click.stop="onGenerate" pill
                                          :disabled="station == 0"
                                          :variant="Variant">{{ $t('Generate') }}
                                </b-button>
                            </b-col>
                        </b-row>

                        <!-- Tableau de données -->
                        <b-card class="border border-transparent m-0 p-0 h-100 overflow-auto" no-body pill
                                :id="$id('GridCard')" :class="'outline-' + Variant">
                            <b-card-header header-tag="header" class="p-1" role="tab"
                                           :header-bg-variant="'outline-' + Variant">
                                <b-row class="m-0 p-0">
                                    <b-col class="text-left p-1 m-0" cols="11">
                                        <h6 class="m-0 p-0">
                                            {{ $t("Result") }}
                                        </h6>
                                    </b-col>
                                    <b-col class="d-flex justify-content-end p-0 m-0">
                                        <b-button v-if="results.length > 0" size="sm" class="border-0"
                                                  pill :variant="'outline-' + Variant" @click.stop="onExcelExport">
                                            <b-icon v-b-tooltip.hover :title="$t('ExcelExport')"
                                                    icon="file-earmark-excel"
                                                    scale="1.2" role="button"/>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-card-header>
                            <b-card-body class="p-0 m-0">
                                <b-row class="p-0 m-0 h-100" v-if="noData == 0">
                                    <b-col class="m-0 p-2 border d-flex flex-column">
                                        {{ $t('NoData') }}
                                    </b-col>
                                </b-row>
                                <b-row class="p-0 m-0 h-100" v-if="noData > 0">
                                    <b-col class="m-0 p-0 border d-flex flex-column">
                                        <b-table-simple :id="$id('GridWork')" hover small bordered
                                                        :table-variant="Variant"
                                                        no-border-collapse class="mb-0 pb-0 h-100 overflow-auto"
                                                        table-class="h-100" v-if="totalRows() > 0">
                                            <b-thead><!-- :class="'bg-' + Variant +'-light'">-->
                                                <b-tr class="text-center w-100 text-nowrap">
                                                    <b-th v-for="(value, key) in Object.keys(results[0])" :key="key"
                                                          :class="['align-middle']"
                                                          :id="$id(value)">
                                                        {{ $t(value) }}
                                                    </b-th>
                                                </b-tr>
                                            </b-thead>
                                            <b-tbody>
                                                <b-tr v-for="(row, index) in rows()" :key="index"
                                                      class="text-nowrap p-0 bg-white">
                                                    <b-td v-for="(value, key) in rows()[index]" :key="key"
                                                          :class="['align-middle', 'border-light']">
                                                        <!-- Formatage Date -->
                                                        <div v-if="key == 'Date'">
                                                            <template v-if="type == 'DJUReference'">
                                                                {{ new Date(value).getDate() }} {{
                                                                    new Date(value).toLocaleString('default', {month: 'long'})
                                                                }}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="interval == 'Year'">
                                                                    {{ new Date(value).getFullYear() }}
                                                                </template>
                                                                <template v-else-if="interval == 'Month'">
                                                                    {{
                                                                        new Date(value).toLocaleString('default', {month: 'long'})
                                                                    }} {{ new Date(value).getFullYear() }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ new Date(value).toLocaleDateString() }}
                                                                </template>
                                                            </template>
                                                        </div>
                                                        <!-- Formatage Decimal -->
                                                        <div v-else class="text-right">
                                                            {{
                                                                new Intl.NumberFormat(language == "" ? 'fr-FR' : language,
                                                                    {
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 2
                                                                    }).format(value)
                                                            }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                            <b-tfoot class="position-sticky bg-white">
                                                <!-- Sous-total -->
                                                <b-tr class="bg-gray">
                                                    <b-td v-for="(value, key) in Object.keys(results[0])" :key="key"
                                                          sticky-column class="align-middle bg-gray border-light"
                                                          :class="value == 'Date' ? 'text-center' : 'text-right'">
                                                        <template v-if="value == 'Date'">
                                                            {{ $t('Sum') }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                new Intl.NumberFormat(language == "" ? 'fr-FR' : language,
                                                                    {
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 2
                                                                    })
                                                                    .format(results.map(a => (a[value])).reduce((sum, num) => sum + num, 0))
                                                            }}
                                                        </template>
                                                    </b-td>
                                                </b-tr>
                                            </b-tfoot>
                                            <caption class="p-0 px-2">
                                                <b-row v-if="totalRows() > perPage" align-h="between"
                                                       class="w-100 py-1">
                                                    <b-col>
                                                        <b-pagination v-if="totalRows() > perPage"
                                                                      :total-rows="totalRows()"
                                                                      v-model="currentPage" :per-page="perPage"
                                                                      class="p-0 m-0">
                                                            <template #page="{ page, active }">
                                                                {{ page }}
                                                            </template>
                                                        </b-pagination>
                                                    </b-col>
                                                    <b-col class="px-0"></b-col>
                                                    <b-col class="text-right px-0">
                                                        {{
                                                            (currentPage * perPage > totalRows() ? totalRows() : currentPage * perPage) + " " + $t('On') + " " + totalRows()
                                                        }}
                                                    </b-col>
                                                </b-row>
                                            </caption>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">

import {Vue, Watch, Prop, Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import ListItem from "@/types/fields/ListItem";
import EnumItem from "@/types/fields/EnumItem";
import MeteoSourceEnum from "@/enums/MeteoSourceEnum"
import moment from "moment/moment";
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import {API_URL} from "@/App.settings";
import {mixins} from "vue-class-component";
import {ThemeUtils} from "@/components/commons/Utils";
import Download from "@/types/Download";
import DownloadStateEnum from "@/enums/DownloadStateEnum";
/** Traductions */
import locales from './locales/ExportDJU.json';

@Component({
    components: {},
    i18n: {messages: locales}
})
export default class ExportDJU extends mixins(Vue, ThemeUtils) {

    @Prop({default: () => 'primary'})
    public Variant: string;

    /** Getter pour obtenir une liste */
    @Getter('GetListEnums')
    protected listEnums!: (listName: string) => EnumItem[];

    @Getter('SessionStore/GetLanguage')
    private language!: string;

    /** @Liste YesNoEnum à charger dynamiquement !!! */
    private yesNoEnum = [
        {value: 'None', text: this.$t('None').toString(), id: 0}, // $t('Yes') / Oui
        {value: 'Yes', text: this.$t('Yes').toString(), id: 1}, // $t('Yes') / Oui
        {value: 'No', text: this.$t('No').toString(), id: 2} // $t('No') / Non
    ];

    //#region Paramètre de recherche
    private collapsedStation: boolean = true;
    private collapsedInterval: boolean = true;

    private usage: number = 1;
    private type: string = '';
    private source: number = 2;
    private station: number = 0;
    private stationInfo: ListItem;
    private method: number = 0;
    private base: number = 0;
    private baseList: { Value: number }[] = [];
    private sourceList: EnumItem[] = [];
    private stationList: ListItem[] = [];
    private methodList: EnumItem[] = [];

    private interval: string = 'Period';
    private startDate: string = new Date(Date.now()).getFullYear() + '-01-01';
    private endDate: string = new Date(Date.now()).toJSON().substring(0, 10);
    private startYear: number = new Date(Date.now()).getFullYear();
    private endYear: number = new Date(Date.now()).getFullYear();
    private startMonth: string = ('0' + (new Date(Date.now()).getMonth() + 1 /* Premier mois - janvier */).toString()).slice(-2);
    private endMonth: string = ('0' + (new Date(Date.now()).getMonth() + 1 /* Premier mois - janvier */).toString()).slice(-2);

    /** Années disponibles */
    private yearList: { Id: number, Label: string }[] = [];
    private monthList: { Id: string, Label: string }[] = [];

    //#endregion

    //#region Tableau

    private results = [];
    private perPage: number = 5;
    private currentPage: number = 1;
    private noData: number = -1;

    //#endregion

    @Watch("source", {immediate: true})
    private async updateSource() {
        this.noData = -1;
        this.$store.dispatch("ShowLoadingMask", this.$t('Loading').toString());
        await this.$store.dispatch("LoadListItems", [
            {
                listName: 'MeteoStationCity',
                targetFilter: 'SourceMeteoCorrector',
                filterValue: this.source
            }]).then(response => {
            this.stationList = this.$store.getters["GetListItems"]('MeteoStationCity', 'SourceMeteoCorrector', this.source);
        });
        this.station = 0;
        this.$store.dispatch("HideLoadingMask", {});
    }

    @Watch("station", {immediate: true})
    private updateStation() {
        this.noData = -1;
        this.type = 'DJU';
        this.interval = 'Period';

        this.stationInfo = this.stationList.find(a => a.Id == this.station);
        if (this.stationInfo?.Extras["MeteoCorrectors"].length > 0) {
            this.base = this.stationInfo.Extras["MeteoCorrectors"][0].Base;
            this.method = this.stationInfo.Extras["MeteoCorrectors"][0].Method;
            this.usage = this.stationInfo.Extras["MeteoCorrectors"][0].Usage;
        } else {
            this.method = 2;
            this.usage = 1;
        }
        this.updateUsage();
    }

    @Watch("type", {immediate: true})
    private updateType() {
        this.noData = -1;

        if (this.type == 'DJUReference' &&
            this.stationInfo.Extras["MeteoCorrectors"][0].GenerateStartDate && this.stationInfo.Extras["MeteoCorrectors"][0].GenerateStartDate != null &&
            this.stationInfo.Extras["MeteoCorrectors"][0].GenerateEndDate && this.stationInfo.Extras["MeteoCorrectors"][0].GenerateEndDate != null) {
            this.interval = 'Period';
            this.startDate = this.stationInfo.Extras["MeteoCorrectors"][0].GenerateStartDate?.split('T')[0];
            this.endDate = this.stationInfo.Extras["MeteoCorrectors"][0].GenerateEndDate?.split('T')[0];
        } else {
            this.updateInterval();
        }
    }

    @Watch("usage", {immediate: true})
    private updateUsage() {
        this.noData = -1;
        if (this.stationInfo?.Extras["MeteoCorrectors"].length > 0) {
            this.baseList = this.stationInfo?.Extras["MeteoCorrectors"].filter(a => a.Usage == this.usage)
                .map((a) => ({Value: a.Base}));
        }
    }

    /**
     * Remise des valeurs par défaut.
     * @private
     */
    @Watch("interval", {immediate: true})
    private updateInterval() {
        this.noData = -1;
        let date = new Date(Date.now());
        this.startDate = date.getFullYear() + '-01-01';
        this.endDate = date.toJSON().substring(0, 10);
        this.startYear = date.getFullYear();
        this.endYear = date.getFullYear();
        this.startMonth = ('0' + (date.getMonth() + 1 /* Premier mois - janvier */).toString()).slice(-2);
        this.endMonth = ('0' + (date.getMonth() + 1 /* Premier mois - janvier */).toString()).slice(-2);
    }

    /** Calcul de la hauteur restante et du nombre de lignes possible */
    private setPerPage() {
        let elem = document.getElementById(this.$id('GridCard'));
        let page = document.getElementById(this.$id('ExportDJUCard'));

        if (elem != null && page != null) {
            console.debug('ExportDJU - setPerPage :', page.getBoundingClientRect(),
                elem.getBoundingClientRect(), page.getBoundingClientRect().height - elem.getBoundingClientRect().top);

            let calcPerPage: number =
                ((page?.getBoundingClientRect().height ?? 0) - (elem?.getBoundingClientRect().top ?? 0) -
                    (35 /* taille du card header */ + 30  /* taille du table header */ + 60 /* taille du table footer + caption */)) / 30;
            this.perPage = calcPerPage > 1 ? Math.trunc(calcPerPage) : 1;
        }
    }

    /** Retourne le nombre de lignes totales du tableau */
    private totalRows(): number {
        return this.results?.length;
    }

    /** Retourne le nombre de lignes selon le contexte */
    private rows(): any[] {
        const items = this.results;
        return items?.slice(
            (this.currentPage - 1) * this.perPage,
            this.currentPage * this.perPage
        );
    }

    /** Récupération des valeurs demandées à partir du serveur */
    public onGenerate() {
        this.$store.dispatch("ShowLoadingMask", this.$t('LoadingInProgress'));

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        args["Usage"] = this.usage;
        args["Type"] = this.type;
        args["Station"] = this.station;
        args["Method"] = this.method;
        args["Base"] = this.base;
        args["Interval"] = this.interval;
        switch (this.interval) {
            case "Period" :
                args["StartDate"] = this.startDate;
                args["EndDate"] = this.endDate;
                break;
            case "Year" :
                args["StartDate"] = new Date(Date.UTC(this.startYear, 0 /* premier mois*/, 1)).toISOString().split('T')[0]
                args["EndDate"] = new Date(Date.UTC(this.endYear, 11 /* dernier mois*/, 31)).toISOString().split('T')[0];
                break;
            case "Month":
                args["StartDate"] = new Date(Date.UTC(this.startYear, parseInt(this.startMonth) - 1, 1)).toISOString().split('T')[0]
                let endDate = new Date(Date.UTC(this.endYear, parseInt(this.endMonth), 1));
                endDate.setDate(endDate.getDate() - 1);
                args["EndDate"] = endDate.toISOString().split('T')[0];
                break;
        }

        axios.post(API_URL + "Meteo/LoadExport", args).then((response) => {
            if (response && response.data) {
                this.results = response.data.Result;
                this.noData = this.results.length;
                this.currentPage = 1;
            }
            this.setPerPage();

            this.$store.dispatch("HideLoadingMask", {});
        }).catch(error => {
            console.error(error);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                /** "Une erreur s'est produite" */
                title: this.$t('Error').toString(),    // "Erreur"
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }).finally(() => {
            this.$store.dispatch("HideLoadingMask", {});
        });
    }

    private async onExcelExport() {
        let index: number = this.$store.getters['DownloadingStore/GetLastIndex'];
        let download: Download = {
            Index: ++index,
            Name: this.$t('Export') + "_" + this.stationList.find(a => a.Id == this.station)?.Label + "_" +
                this.$tc(this.type) + "_" +
                (this.usage == 1  /* Chauffage */ ? this.$t('MeteoHeating') : (this.usage == 7 /* Climatisation */ ? this.$t('MeteoCooling') : "")) + "_" +
                (this.source != undefined ? this.sourceList.find(a => a.Id == this.source.toString()).Label : "") +
                ' (' + index.toString() + ')' + ".xlsx",
            Type: ".xlsx",
            State: DownloadStateEnum.InProgress,
            Data: "",
            Direct: false
        };
        this.$store.dispatch('DownloadingStore/AddDownloading', download);

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        args["Parameters"] = {};
        args["Parameters"]["Usage"] = this.usage == 1  /* Chauffage */ ? this.$t('MeteoHeating') : (this.usage == 7 /* Climatisation */ ? this.$t('MeteoCooling') : "");
        args["Parameters"]["Type"] = this.$t('MeteoType' + this.type);
        args["Parameters"]["Source"] = this.source != undefined ? this.sourceList.find(a => a.Id == this.source.toString()).Label : "";
        args["Parameters"]["Station"] = this.stationList.find(a => a.Id == this.station)?.Label;
        args["Parameters"]["Method"] = this.method != undefined ? this.methodList.find(a => a.Id == this.method.toString()).Label : "";
        args["Parameters"]["Base"] = this.base.toString() + '°C';
        args["Parameters"]["Interval"] = this.interval;
        switch (this.interval) {
            case "Period" :
                args["Parameters"]["StartDate"] = new Date(this.startDate).toLocaleDateString();
                args["Parameters"]["EndDate"] = new Date(this.endDate).toLocaleDateString();
                break;
            case "Year" :
                args["Parameters"]["StartDate"] = this.startYear;
                args["Parameters"]["EndDate"] = this.endYear;
                break;
            case "Month":
                args["Parameters"]["StartDate"] = this.startMonth + '/' + this.startYear;
                args["Parameters"]["EndDate"] = this.endMonth + '/' + this.endYear;
                break;
        }

        args["Datas"] = this.results.map(a => ({
            ...a,
            Date: this.type == "DJUReference" ? new Date(a.Date).getDate() + " " + new Date(a.Date).toLocaleString('default', {month: 'long'}) :
                (this.interval == 'Period' ? new Date(a.Date).toLocaleDateString() :
                    (this.interval == 'Year' ? new Date(a.Date).getFullYear() :
                            this.interval == 'Month' ? new Date(a.Date).toLocaleString('default', {month: 'long'}) + " " + new Date(a.Date).getFullYear() : ""
                    ))
        }));

        await axios.post(API_URL + 'Meteo/DownloadExport', args, {responseType: 'blob'}).then((response) => {
            let results: Dictionary<any> = response.data;
            this.$store.dispatch('DownloadingStore/AddData', {index, data: results});
            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Finished});
        }).catch(err => {
            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Error})
            this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        });
    }

    async mounted() {
        await this.$store.dispatch("LoadListEnums", {
            featureName: undefined,
            enumNames: ['MeteoSource']
        }).then(response => {
            this.sourceList = this.listEnums('MeteoSource').filter(a => a.Id != MeteoSourceEnum.Client.toString() /* Client en supervision */
                && a.Id != MeteoSourceEnum.None.toString() /* Aucun */);
        });
        await this.$store.dispatch("LoadListEnums", {
            featureName: undefined,
            enumNames: ['MeteoMethodCorrector']
        }).then(response => {
            this.methodList = this.listEnums('MeteoMethodCorrector');
        });
        await this.updateSource();

        // Définition des mois avec la librairie Moment en tenant compte de la langue Utilisateur
        let dateStart: moment.Moment = moment('01/01/1990').locale((this.language == "" ? 'fr-FR' : this.language).substring(1, 2));
        this.monthList = [];
        Array(12).fill(1)
            .forEach((item, index) => {
                let date = dateStart.format('MMMM');
                dateStart.add({months: 1});
                let id: string = ('0' + (index + 1));
                this.monthList.push(({
                    Id: id.substring(id.length - 2),
                    Label: date.charAt(0).toUpperCase() + date.slice(1)
                }));
            });

        let date = new Date(Date.now());
        this.startDate = date.getFullYear() + '-01-01';

        let lastYear = date.getFullYear();
        for (let year = lastYear; year >= 1999; year--) {
            this.yearList.push({Id: year, Label: year.toString()});
        }
    }

    updated() {
        /// pour le changement d'affichage des variables dont les collapses
        this.setPerPage();
    }
}
</script>

<style scoped>
:deep(input[type=checkbox]:checked) {
    /** Change la couleur de la checkbox */
    accent-color: var(--Variant) !important;
}

:deep(input[type=radio]:checked) {
    /** Change la couleur du bouton radio */
    accent-color: var(--Variant) !important;
}

/** Pour que la page active prenne en compte la couleur de Variant */
:deep(.page-item.active .page-link) {
    background-color: var(--Variant) !important;
}

:deep(.page-link:hover) {
    background-color: var(--VariantLight) !important;
}
</style>